import { Tab } from '@headlessui/react';

interface TabsProps {
  tabs: { key: string; label: string; badge?: number | string }[];
  children: React.ReactNode;
  onChange?: (key: string) => void;
  defaultIndex?: number;
  className?: string;
}

export function Tabs({ tabs, children, onChange, defaultIndex = 0, className = '' }: TabsProps) {
  return (
    <Tab.Group
      defaultIndex={defaultIndex}
      onChange={(index) => onChange?.(tabs[index].key)}
    >
      <Tab.List className={`flex border-b border-gray-200 ${className}`}>
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            className={({ selected }) =>
              `px-4 py-3 text-sm font-medium -mb-px border-b-2 transition-colors duration-200
               ${selected
                 ? 'border-blue-600 text-blue-600'
                 : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
               }
               ${tab.badge ? 'flex items-center gap-2' : ''}`
            }
          >
            {tab.label}
            {tab.badge !== undefined && (
              <span
                className={`
                  px-2 py-0.5 text-xs rounded-full
                  ${!tab.badge ? 'bg-gray-100 text-gray-600' :
                    typeof tab.badge === 'number' && tab.badge > 0 ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}
                `}
              >
                {tab.badge}
              </span>
            )}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="mt-4">{children}</Tab.Panels>
    </Tab.Group>
  );
}

export function TabPanel({ children }: { children: React.ReactNode }) {
  return <Tab.Panel>{children}</Tab.Panel>;
}
